import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponseModel, ResponseModel } from '@models/app.model';
import {
    ChangeOrderStatusRequest,
    CreateOrderHistoryLogRequest,
    OrderAssignRequest,
    OrderContactRequest,
    OrderDetail,
    OrderHistoryLogs,
    OrderPaymentInfoResponse,
    SearchOrderReq,
    SearchOrderResponse,
    ServiceFeeOfOrderDetail,
    SyncOrderRequest,
    SyncOrderResponse
} from '@models/order.model';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OrderService {
    constructor(private httpService: HttpService) {}

    public getOrderManagement(reqParams: SearchOrderReq): Observable<BaseResponseModel<SearchOrderResponse[]>> {
        return this.httpService.get('Order/SearchListOrder', {
            params: new HttpParams({ fromObject: { ...reqParams } }),
        });
    }

    public getDetailOrderByCode(code: string): Observable<BaseResponseModel<OrderDetail>> {
        return this.httpService.get('Order/OrderDetail', {
            params: new HttpParams({
                fromObject: {
                    code,
                },
            }),
        });
    }

    public getOrderPaymentInfo(transactionId: string): Observable<BaseResponseModel<OrderPaymentInfoResponse[]>> {
        return this.httpService.get('Order/GetOrderPaymentInfo', {
            params: new HttpParams({
                fromObject: {
                    transactionId: transactionId,
                },
            }),
        });
    }

    public changeOrderContact(reqBody: OrderContactRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Order/ChangeContact', reqBody, {
            updateLoading: true,
        });
    }

    public getOrderHistoryLogs(transactionId: string): Observable<BaseResponseModel<OrderHistoryLogs[]>> {
        return this.httpService.get('Order/GetOrderHistoryLogs', {
            params: new HttpParams({
                fromObject: {
                    code: transactionId,
                },
            }),
        });
    }

    public changeOrderAssign(reqBody: OrderAssignRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Order/OrderAssignUser', reqBody, {
            updateLoading: true,
        });
    }

    public checkAddBookingToOrder(reqBody: SyncOrderRequest): Observable<SyncOrderResponse> {
        return this.httpService.post('Order/CheckAddBookingToOrder', reqBody, {
            updateLoading: true,
        });
    }

    public addBookingToOrder(reqBody: SyncOrderRequest): Observable<BaseResponseModel<SyncOrderResponse>> {
        return this.httpService.post('Order/AddBookingToOrder', reqBody, {
            updateLoading: true,
        });
    }

    public changeOrderStatus(reqBody: ChangeOrderStatusRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Order/ChangeOrderStatus', reqBody, {
            updateLoading: true,
        });
    }

    public createOrderHistoryLog(reqBody: CreateOrderHistoryLogRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Order/CreateOrderHistoryLog', reqBody, {
            updateLoading: true,
        });
    }

    public getServiceFeeOfOrderDetail(transactionId: string): Observable<BaseResponseModel<ServiceFeeOfOrderDetail>> {
        return this.httpService.get('Order/GetServiceFeeOfOrderDetail', {
            params: new HttpParams({
                fromObject: {
                    transactionId: transactionId,
                },
            }),
        });
    }

    public updateServiceFeeOfOrderDetail(reqBody: any): Observable<BaseResponseModel<any>> {
        return this.httpService.post('Order/UpdateServiceFee', reqBody, {
            updateLoading: true,
        });
    }
}
